import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Recipes } from 'features/Recipes'
import Script from 'next/script'
export default function RecipesPage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Meet our Meats.',
    url: 'https://wefeedraw.com/recipes',
    description:
      'Protein-rich. Nutrient-dense. Perfectly Balanced. This is the clean fuel your dog deserves.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'WebPage',
            name: 'More Happy, Healthy Dog Days.',
            url: 'https://wefeedraw.com/recipes#recipes-1',
            description:
              'Start your dog on their ancestral diet today and see positive results in as little as one week.',
            about: {
              '@type': 'CreativeWork',
              name: 'More Happy, Healthy Dog Days.',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'WebPage',
            name: 'Raw Meals Made Right, Made Easy.',
            url: 'https://wefeedraw.com/recipes#recipes-2',
            description: 'Safety, convenience, quality and results.',
            about: {
              '@type': 'CreativeWork',
              name: 'Raw Meals Made Right, Made Easy.',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'WebPage',
            name: 'How Do We Compare?',
            url: 'https://wefeedraw.com/recipes#recipes-3',
            description: 'Compare kibble, canned, cooked and freezer aisle to raw dog food.',
            about: {
              '@type': 'CreativeWork',
              name: 'How Do We Compare?',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'WebPage',
            name: 'The Stats Speak',
            url: 'https://wefeedraw.com/recipes#recipes-4',
            description: 'We polled our customers and this is what they had to say.',
            about: {
              '@type': 'CreativeWork',
              name: 'The Stats Speak',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('recipes:overview.page-title')}</title>
        <meta name="title" content={t('recipes:overview.meta-title')} />
        <meta name="description" content={t('recipes:overview.meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes" />
      </Head>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
      <main>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
        <Recipes />
      </main>
    </>
  )
}
